/**
 * useEltJobDetails Hook
 *
 * React Query hook for fetching a single ELT job.
 */

import { useQuery } from '@tanstack/react-query';
import { eltJobService } from '../../../api/elt-job.service';
import type { EltJob } from '../../../types/elt-job.types';

export const ELT_JOB_DETAILS_QUERY_KEY = 'eltJobDetails';

export function useEltJobDetails(tenantId: string, eltJobId: string) {
  return useQuery<EltJob, Error>({
    queryKey: [ELT_JOB_DETAILS_QUERY_KEY, tenantId, eltJobId],
    queryFn: () => eltJobService.getEltJob(tenantId, eltJobId),
    enabled: !!tenantId && !!eltJobId,
    staleTime: 30000,
  });
}
